import React from "react";

const SkeletonNFTCard = () => {
  return (
    <div className="bg-white dark:bg-jacarta-700 rounded-lg border border-jacarta-100 dark:border-jacarta-600 overflow-hidden animate-pulse">
      {/* Image Placeholder - 5:4 aspect ratio to match NFTCard */}
      <div className="w-full aspect-[5/4] bg-grayish/20 dark:bg-jacarta-600"></div>

      {/* Content Section - matches NFTCard padding and spacing */}
      <div className="p-5 space-y-4">
        {/* Title Placeholder - single line first, then partial second line */}
        <div className="space-y-2">
          <div className="h-6 bg-grayish/20 dark:bg-jacarta-600 rounded w-full"></div>
          <div className="h-6 bg-grayish/20 dark:bg-jacarta-600 rounded w-2/3"></div>
        </div>

        {/* Creator Badge Placeholder - matches the actual size better */}
        <div className="flex items-center gap-2.5">
          <div className="w-6 h-6 bg-grayish/20 dark:bg-jacarta-600 rounded-full flex-shrink-0"></div>
          <div className="h-3.5 bg-grayish/20 dark:bg-jacarta-600 rounded w-20"></div>
        </div>

        {/* Price and Button Section - matches border-t styling */}
        <div className="flex items-center justify-between pt-4 border-t border-jacarta-100 dark:border-jacarta-600">
          <div className="space-y-1">
            <div className="h-3 bg-grayish/20 dark:bg-jacarta-600 rounded w-8"></div>
            <div className="h-7 bg-grayish/20 dark:bg-jacarta-600 rounded w-12"></div>
          </div>
          <div className="h-10 bg-grayish/20 dark:bg-jacarta-600 rounded-lg w-24"></div>
        </div>
      </div>
    </div>
  );
};

// Skeleton component for list view
export const SkeletonListItem = ({ viewType = "desktop" }) => {
  const baseClasses =
    "bg-white dark:bg-jacarta-700 border border-jacarta-100 dark:border-jacarta-600 rounded-lg mb-2 animate-pulse";

  if (viewType === "desktop") {
    return (
      <div className={`flex ${baseClasses}`}>
        <div className="flex w-[35%] items-center py-4 px-4">
          <div className="w-5 h-4 bg-grayish/20 dark:bg-jacarta-600 rounded mr-3 lg:mr-5"></div>
          <div className="w-10 h-10 lg:w-12 lg:h-12 bg-grayish/20 dark:bg-jacarta-600 rounded-lg mr-2 lg:mr-5"></div>
          <div className="space-y-2 flex-1">
            <div className="h-4 bg-grayish/20 dark:bg-jacarta-600 rounded w-3/4"></div>
            <div className="h-3 bg-grayish/20 dark:bg-jacarta-600 rounded w-1/2"></div>
          </div>
        </div>
        <div className="w-[13%] py-4 px-4 flex justify-center">
          <div className="h-5 bg-grayish/20 dark:bg-jacarta-600 rounded w-16"></div>
        </div>
        <div className="w-[13%] py-4 px-4 flex justify-center">
          <div className="h-4 bg-grayish/20 dark:bg-jacarta-600 rounded w-12"></div>
        </div>
        <div className="w-[13%] py-4 px-4 flex justify-center">
          <div className="h-4 bg-grayish/20 dark:bg-jacarta-600 rounded w-8"></div>
        </div>
        <div className="w-[13%] py-4 px-4 flex justify-center">
          <div className="h-8 bg-grayish/20 dark:bg-jacarta-600 rounded w-16"></div>
        </div>
      </div>
    );
  }

  if (viewType === "tablet") {
    return (
      <div className={`flex ${baseClasses}`}>
        <div className="flex w-[45%] items-center py-4 px-4">
          <div className="w-5 h-4 bg-grayish/20 dark:bg-jacarta-600 rounded mr-3"></div>
          <div className="w-10 h-10 bg-grayish/20 dark:bg-jacarta-600 rounded-lg mr-3"></div>
          <div className="space-y-2 flex-1">
            <div className="h-4 bg-grayish/20 dark:bg-jacarta-600 rounded w-3/4"></div>
            <div className="h-3 bg-grayish/20 dark:bg-jacarta-600 rounded w-1/2"></div>
          </div>
        </div>
        <div className="w-[18%] py-4 px-4 flex justify-center">
          <div className="h-5 bg-grayish/20 dark:bg-jacarta-600 rounded w-16"></div>
        </div>
        <div className="w-[18%] py-4 px-4 flex justify-center">
          <div className="h-4 bg-grayish/20 dark:bg-jacarta-600 rounded w-8"></div>
        </div>
        <div className="w-[19%] py-4 px-4 flex justify-center">
          <div className="h-8 bg-grayish/20 dark:bg-jacarta-600 rounded w-16"></div>
        </div>
      </div>
    );
  }

  // Mobile view
  return (
    <div className={`${baseClasses} p-4`}>
      <div className="flex items-center gap-3 mb-3">
        <div className="w-4 h-4 bg-grayish/20 dark:bg-jacarta-600 rounded"></div>
        <div className="w-12 h-12 bg-grayish/20 dark:bg-jacarta-600 rounded-lg"></div>
        <div className="space-y-2 flex-1">
          <div className="h-4 bg-grayish/20 dark:bg-jacarta-600 rounded w-3/4"></div>
          <div className="h-3 bg-grayish/20 dark:bg-jacarta-600 rounded w-1/2"></div>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="h-5 bg-grayish/20 dark:bg-jacarta-600 rounded w-16"></div>
        <div className="h-8 bg-grayish/20 dark:bg-jacarta-600 rounded w-20"></div>
      </div>
    </div>
  );
};

export default SkeletonNFTCard;
